import React from 'react'
import { IArticlesProps, PromoAdapterProps, IArticle } from '../../types'
import { formatDate, promo } from './helpers'
import { getFeCroppedImage } from '../../utils'

export const ArticlesComponent: React.FC<IArticlesProps> = props => {
    const artCnt = props.articles.length
    const isLast = (idx: number) => artCnt === idx + 1

    const Promo: React.FC<PromoAdapterProps> = ({ idx, show }) => {
        if(!show)
            return null
        return props.promo[idx] ?? null
    }

    return (
        <>
            {props.articles.map((art, idx) => (
                <React.Fragment key={art.articleUrl}>
                    <Promo show={promo(idx).shouldShow} idx={promo(idx).promoComponentIdx} />
                    <Item {...art} />
                    <Promo show={artCnt <=6 && isLast(idx)} idx={0} />
                </React.Fragment >
            ))}
        </>
    )
}

export const Item: React.FC<IArticle> = props => {
    return (
        <>
            <a href={props.articleUrl} className="art-list__item" key={props.articleUrl.toLowerCase()}>
                <picture className="art-list__item__img">
                    <source srcSet={ getFeCroppedImage(props.imageUrl.desktop,400)} media="(min-width: 1200px)" />
                    <source srcSet={getFeCroppedImage(props.imageUrl.tablet,350)} media="(min-width: 768px)" />
                    <img src={getFeCroppedImage(props.imageUrl.mobile,600)} loading='lazy' />
                </picture>
                <span className="art-list__item__type">{props.typeName}</span>
                <h3 className="art-list__item__title">{props.articleTitle}</h3>
                <p className="art-list__item__text" dangerouslySetInnerHTML={{__html:props.introductionText}}></p>
                <span className="art-list__item__date">{formatDate(props.articleDate)}</span>
            </a>
        </>
    )
}
